import { useEffect } from 'react'
import { useDeviceOrientation } from '../hooks/useDeviceOrientation'

export function Overlay() {
    const { orientation, error, requestAccess, revokeAccess } = useDeviceOrientation()

    const orientationInfo = orientation && (
        <ul>
            <li>
                ɑ: <code>{orientation.alpha}</code>
            </li>
            <li>
                β: <code>{orientation.beta}</code>
            </li>
            <li>
                γ: <code>{orientation.gamma}</code>
            </li>
        </ul>
    )

    // useEffect(() => {
    //     console.log('[Overlay.js] orientation', orientation)
    //     requestAccess()
    // }, [orientation])

    const errorElement = error ? <div className="error">{error.message}</div> : null

    const profilePicture = 'https://avatars.githubusercontent.com/u/78725068?v=4'
    return (
        <>
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    pointerEvents: 'none',
                    width: '100%',
                    height: '100%',
                    color: 'white'
                }}>
                <a
                    href="https://pmnd.rs/"
                    style={{
                        position: 'absolute',
                        bottom: 40,
                        left: 40,
                        fontSize: '12px',
                        color: 'white'
                    }}>
                    clearly inspired by <strong>pmnd.rs</strong> &
                    <br />
                    <strong>monopo company</strong>
                </a>
                <div
                    style={{
                        position: 'absolute',
                        top: 40,
                        left: 40,
                        fontSize: '13px',
                        color: 'white',
                        display: 'flex'
                    }}>
                    {/* <a href={'https://github.com/vincentdchn'}> */}
                    <img
                        className="w-12 avatar rounded-full w-10 h-10"
                        src={profilePicture}
                        alt={`Hey, that's me.`}
                        onClick={() => {
                            requestAccess()
                        }}
                    />
                    {/* </a> */}
                    <div className="pl-3">
                        vincentdchn — <br />
                        web dev
                    </div>
                </div>
                <div
                    style={{
                        position: 'absolute',
                        bottom: 60,
                        right: 40,
                        fontSize: '12px',
                        color: 'white'
                    }}>
                    <a href={'https://github.com/vincentdchn'}> Github</a> -{' '}
                    <a href={'https://www.linkedin.com/in/vincent-duch%C3%AAne-18b04597/'}>LinkedIn</a>
                </div>
            </div>
            <div></div>
        </>
    )
}
